import React from 'react'
import MaterialSymbol from '../material-symbol'

const UnfoldMore = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="unfold_more" {...props} />
))

UnfoldMore.displayName = 'UnfoldMore'

export default UnfoldMore
